import React from 'react';
import { Box } from '@mui/material';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import ApplicationsTable from '../../components/ApplicationsTable/ApplicationsTable';

// clients page for coach
// TODO: add search table
const Applications = () => (
  <CoachPageLayout>
    <Box height="100%" width="100%">
      <Box
        border="black"
        height="100%"
        bgcolor="#fff"
        borderRadius="5px"
        sx={{ boxShadow: (theme) => theme.borderStyles.cardBorders }}
      >
        <ApplicationsTable />
      </Box>
    </Box>
  </CoachPageLayout>
);

export default Applications;
